import { render } from "./HeaderNav.vue?vue&type=template&id=bdacde6c&scoped=true"
import script from "./HeaderNav.vue?vue&type=script&lang=js"
export * from "./HeaderNav.vue?vue&type=script&lang=js"

import "./HeaderNav.vue?vue&type=style&index=0&id=bdacde6c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bdacde6c"

export default script